module.exports = __webpack_public_path__ + "static/media/13200120-8c49-4ac5-9a4f-45c773d67bad.a1aa762e.jpeg";